module.exports = __webpack_public_path__ + "enterprise.zwzCGMDi.svg";